<template>
    <div>
        
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3 col-md-2">

                    <MenuPacote></MenuPacote>

                </div>

                <div class="col-lg-9 col-md-10">

                    <ConjuntosMenu></ConjuntosMenu>

                    <div class="panel">
                        <div class="panel-header">
                            Documentos
                        </div>
                        <div class="panel-content">
                            
                            <arquivos style="margin-top:15px;margin-bottom:25px;"
                            name="Declaração do fabricante" 
                            ext="declaracao_fabricante" 
                            :id="$route.params.carga" 
                            :multiple="false" 
                            :limit="1" />

                            <arquivos style="margin-top:15px;margin-bottom:25px;"
                            name="Desenho" 
                            ext="desenho" 
                            :id="$route.params.carga" 
                            :multiple="false" 
                            :limit="1" />

                            <arquivos style="margin-top:15px;margin-bottom:25px;"
                            name="Estudo de Viabilidade Geometrica" 
                            ext="evg" 
                            :id="$route.params.carga" 
                            :multiple="false" 
                            :limit="1" />

                            <arquivos style="margin-top:15px;margin-bottom:25px;"
                            name="Nota fiscal" 
                            ext="nota_fiscal" 
                            :id="$route.params.carga" 
                            :multiple="false" 
                            :limit="1" />

                            

                            <arquivos style="margin-top:15px;margin-bottom:25px;"
                            name="Fotos do conjunto" 
                            ext="fotos_conjunto" 
                            :id="$route.params.carga" 
                            :multiple="false" 
                            :limit="1" />
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import arquivos from '@/components/arquivos'
import MenuPacote from '@/modules/super/pages/MenuPacote'
import ConjuntosMenu from '@/modules/super/pages/menus/conjunto-menu'

export default {
    name:"Documentos",
    components:{
        arquivos, MenuPacote, ConjuntosMenu
    }
}
</script>